import Constants from "../constants"
import axios from "axios";

const state = {
    loading: false,
    list: [],
    current: null,
    count: 0,
    contactedCount: 0,
    error: null,
    search: null,
    options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['symptom_count'],
        sortDesc: [true]
    },
    questionnaires: null
};

const getters =  {
    list(state) {
        if (state.search) {
            const searchTerm = state.search.toLowerCase()
            return state.list.filter(x => {
                return (x.name && x.name.toLowerCase().includes(searchTerm)) ||
                   (x.phone_number && searchTerm.replace(/\D/g,'').length >= 2 && x.phone_number.replace(/\D/g,'').includes(searchTerm.replace(/\D/g,''))) ||
                   (x.insurance_id && x.insurance_id.toLowerCase().includes(searchTerm)  )
            })
        }
        return state.list;
    },
    current(state) {
        return state.current;
    },
    search(state) {
        return state.search;
    },
    count(state) {
        return state.count
    },
    contactedCount(state) {
        return state.contactedCount
    },
    loading(state) {
        return state.loading;
    },
    error(state) {
        return state.error;
    },
    options(state) {
        return state.options;
    },
    questionnaires(state) {
        return state.questionnaires;
    }
}

const mutations = {
    setUsers(state, payload) {
        state.list = payload;
    },
    setCurrent(state, payload) {
        state.current = payload;
    },
    setCount(state, payload) {
        state.count = payload
    },
    setContactedCount(state, payload) {
        state.contactedCount = payload
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
    setError(state, payload) {
        state.error = payload;
    },
    clearError(state) {
        state.error = null;
    },
    setSearch(state,payload) {
        state.search = payload;
    },
    setOptions(state,payload) {
        if (payload.sortBy.length=== 0) {
            payload.sortBy = state.options.sortBy;
            payload.sortDesc.push(!state.options.sortDesc)
        }
        state.options = payload;
    },
    setQuestionnaires(state, questionnaires) {
        state.questionnaires = questionnaires;
    }
}

const actions = {
    async loadList({commit}) {

        commit('setLoading', true);

        axios.get(Constants.apiBaseURL+'dashboard/users/all', {

        })
            .then(response => {
                let users = response['data']['data'][0];
                commit('setCount',  users.length);
                commit('setContactedCount', users.filter(x => x.is_intervened).length)
                commit('setUsers',  users);
                commit('setLoading', false);
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
            });
    },

    async loadOne({commit,state}, id) {
        if (state.current && state.current.id === id) {
            return
        } else {
            commit ('setCurrent', null)
        }
        commit('setLoading', true);
        axios.get(Constants.apiBaseURL+'dashboard/users/'+id, {})
            .then(response => {
                let user = response['data']['data'][0];
                commit('setCurrent',  user);
                commit('setLoading', false);
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
            });
    },

    async loadListCancer({commit}) {

        commit('setLoading', true);

        axios.get(Constants.apiBaseURL+'dashboard/users/all-cancer')
            .then(response => {
                let users = response['data']['data'][0];
                commit('setCount',  users.length);
                commit('setUsers',  users);
                commit('setLoading', false);
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
            });
    },
    async getQuestionnaires({commit}, payload) {
        axios.get(Constants.apiBaseURL+'dashboard/get-questionnaires-by-user/'+payload)
            .then(response => {
                commit('setQuestionnaires', response.data.data);
            })
            .catch(error => {
                commit('setLoading', false);
                commit('setError', error);
            });
    },

    clearError({commit}) {
        commit('clearError');
    },
}

export default {
    namespaced: true,
    state,
    getters, 
    mutations,
    actions
}

